import { HostListener, Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IReturnObject } from '../shared/return-object.model';
import { ErrorTypeEnum } from '../shared/enums.model';
import { Observable } from 'rxjs/Observable';
import { root } from 'rxjs/src/util/root';
import { ChipsModule } from 'primeng/primeng';

import { ImageLibraryService } from './image-library.service';
import { PictureBe } from './shared/image-model';
import { AppConfig } from '../config/app.config';
import { ComponentCanDeactivate } from '../../app/shared/page.pendingchangesguard';
import { ChineseChangeValueService } from '../chinese-change-value.service';
import { NgbModal,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { ImageWarningBeforeUploadComponent } from '../image-warning-before-upload/image-warning-before-upload.component';


declare var jQuery: any;
declare var Dropzone: any;
@Component({
    moduleId: module.id,
    selector: 'image-library',
    templateUrl: 'image-library.html',
    styleUrls: ['../packaging-instruction/packaging-instruction.css'],
    providers: [ImageLibraryService]
})
export class ImageLibraryComponent implements OnInit, ComponentCanDeactivate {
    constructor(private imageLibService: ImageLibraryService,
        private config: AppConfig,
        public ChineseChangeValueService:ChineseChangeValueService,
        private modelService:NgbModal,) { }
        //Opening Pop up
       openWarningModal():void{
        this.modelService.open(ImageWarningBeforeUploadComponent);
         }

    apiUrl: string = this.config.get('apiUrl') + 'ImageLibrary/AddNewImageToLibrary';
    returnObject: PictureBe[] = [];
    failreturnObject: string[] = [];
    viewList = false;
    searchKeyStrokeDelay = 350;
    typeDelayTimer: any = null;
    searchListDelayTimer: any = null;
    searchListDelayTimerDelay = 250;

    searchLabels = '';
    dataFetched = true;
    showDeleteBtn = true;
    showSpinner = false;
    showSpinnerUpload = false;
    SelectAllSearchedText = 'Check to select all ';
    SelectAllUploadedText = 'Check to select all ';
    dropZoneIsHidden = true;

    // Image info
    imageSearchResult: PictureBe[] = [];
    imageSearch = '';
    addedUploadLabels = '';
    uploadLabels: string[] = [];
    searchLables: string[] = [];
    deleteImage = 1; 
    errorType = '';
    searchedLabels: string[] = [];

    @Input() labelsFromParentCtrl = '';
    @Input() PiTitleFromParentCtrl = '';
    @Output() update: EventEmitter<PictureBe> = new EventEmitter<PictureBe>();

    @HostListener('window:beforeunload')
    canDeactivate(): Observable<boolean> | boolean {
        return true;
    }

    ngOnInit() {
        const vm = this;
        if (this.labelsFromParentCtrl !== '' || this.PiTitleFromParentCtrl !== '') {
            this.showDeleteBtn = false;
            this.showSpinner = true;
            this.imageSearch = this.labelsFromParentCtrl;

            this.searchLables = this.imageSearch.length === 0
                ? []
                : this.imageSearch.split('|');

            this.uploadLabels = this.PiTitleFromParentCtrl.length === 0
                ? []
                : this.PiTitleFromParentCtrl.split('|');

            this.addedUploadLabels = this.uploadLabels.join('|');
            this.removeDuplicateLabels();
            this.dropZoneIsHidden = this.addedUploadLabels.split('|').findIndex(x => x.length < 6) >= 0;
            this.showSpinner = false;
        }


        /*DROPZONE*/
            Dropzone.options.dropzone = {

                paramName: 'file',
                maxFilesize: 4,
                uploadMultiple: false,
                // timeout:80000,
                parallelUploads: 1,
                dictFileTooBig: 'Not uploaded, max allowed file size is 4 Mb',
                dictDefaultMessage: 'Drop new images here or click to open file selector. Only images are allowed.',
                dictInvalidFileType: 'Only images .jpeg/png',
                dictResponseError: 'Server reports and error with status code {{statusCode}}',
                acceptedFiles: 'image/*',
                withCredentials: true,
                header: { 'My-Awesome-Header': 'header value' }
            };

            const dZone = new Dropzone('form#dropzone', { url: this.apiUrl });

            dZone.on('success', function (file: any, response: IReturnObject) {
            //    debugger;
                vm.clearFailObject();
                if (response.ErrorType === ErrorTypeEnum.Error) {
                    vm.errorType = 'danger';
                    vm.failreturnObject.push(response.ErrorMsg);
                    setTimeout(function () { vm.clearFailObject(); }, 10000);
                    return;
                }

                if (response.ErrorType === ErrorTypeEnum.Warning) {
                    vm.errorType = 'warning';
                    const msg =  response.ErrorMsg.toLowerCase() === 'already exist'
                        ? 'Uploaded image(s) already exists. The label(s) you typed was added to the exising image(s)'
                        : response.ErrorMsg;
                    vm.failreturnObject.push(msg);
                    setTimeout(function () { vm.clearFailObject(); }, 10000);
                } else {
                    vm.errorType = 'success';
                    vm.failreturnObject.push('Picture(s) successfully added.');
                }

                for (let i = 0; i < response.DataList.length; i++) {
                    const inx = vm.returnObject.findIndex( x => x.Id === response.DataList[i].Id );
                    if ( inx !== -1 ) {
                        vm.returnObject.splice(inx, 1);
                    }

                    response.DataList[i].PictureImage = 'data:image/png;base64,' + response.DataList[i].PictureImage;
                    vm.returnObject.push(response.DataList[i]);
                }
            });

            dZone.on('addedfile', function (file: any) {
            });

            dZone.on('error', function (file: any, errorMessage: string, hxr: XMLHttpRequest) {
                if (file.status === 'error') {
                    alert(errorMessage);
                    dZone.removeFile(file);
                }
            });

            dZone.on('queuecomplete', function () {
                dZone.removeAllFiles();
            });
    }

    removeDuplicateLabels(){
        this.searchLables = this.searchLables.filter(function (item, index, tempTest) {
            return tempTest.indexOf(item) === index;
        });
    }

    searchForImages() {
        this.showSpinner = true;
        this.imageSearch = this.searchLables.join();
        this.imageLibService.getImagesByLabels(this.imageSearch)
            .subscribe(returnObject => this.imageSearchResponse(returnObject));
    }

    imageSearchResponse(returnObject: IReturnObject) {
    //   debugger;
        this.clearFailObject();
        if (returnObject.ErrorType !== ErrorTypeEnum.NoError) {
            this.errorType = 'danger';
            this.failreturnObject.push(returnObject.ErrorMsg);
            const that = this;
            setTimeout(function () { that.clearFailObject(); }, 10000);
                this.imageSearchResult = [];
        } else {
            this.imageSearchResult = returnObject.DataList;

            for (let i = 0; i < this.imageSearchResult.length; i++) {
                const tempImage: any = 'data:image/png;base64,' + this.imageSearchResult[i].PictureImage;
                this.imageSearchResult[i].PictureImage = tempImage;
            }
        }
        this.showSpinner = false;
    }

    disableSearch() {
        return this.searchLables.length < 1;
    }

    labelAlreadySelected(label: string): boolean {
        const inx = this.searchLables.findIndex( x => x === label);
        return inx > -1;
    }

    selectItem(label: string) {
        if (this.labelAlreadySelected(label)) {
            return;
        }

        this.imageSearch += this.imageSearch.length === 0 ? label : '|' + label;
        this.searchLables = this.imageSearch.split('|');
    }

    labelsChanged() {
        this.imageSearch = this.searchLables.join('|');
    }

    uploadLabelsChanged() {
        this.imageSearch = this.uploadLabels.join('|');
        this.addedUploadLabels = this.imageSearch;
        this.dropZoneIsHidden = this.addedUploadLabels.split('|').findIndex(x => x.length < 6) >= 0;
    }

    clearFailObject() {
        this.failreturnObject = [];
    }

    selectImageToPi(imgObj: PictureBe) {
        imgObj.PictureName = this.imageSearch;
        this.update.emit(imgObj);
    }

    getImageLabels() {
        this.showSpinner = false;
        if (this.searchLabels.length >= 2) {
            this.imageLibService.getImageLabels(this.searchLabels)
                .subscribe(returnObject => this.getImageLabelsResponse(returnObject));
        }
    }
    getImageLabelsResponse(returnObject: IReturnObject) {
        this.searchedLabels = returnObject.DataList;
        this.showSpinner = false;
        this.dataFetched = true;
    }

    deleteImageFromLib(imageId: number) {
        this.showSpinner = true;
        this.deleteImage = imageId;
        this.imageLibService.deleteImage(imageId)
            .subscribe(returnObject => this.deleteImageResponse(returnObject));
    }

    deleteImageResponse(returnObject: IReturnObject) {
        this.clearFailObject();
        if (returnObject.ErrorMsg !== '') {
            this.errorType = 'danger';
            this.failreturnObject.push(returnObject.ErrorMsg);
        } else {
            const index = this.imageSearchResult.findIndex(x => x.Id === this.deleteImage);
            this.errorType = 'info';
            this.failreturnObject.push('The picture is now deleted from the library');
            this.imageSearchResult.splice(index, 1);
        }

        this.showSpinner = false;
        const that = this;
        setTimeout(function () { that.clearFailObject(); }, 10000);
    }

    deleteImageFromUploaded(imageId: number) {
        this.showSpinnerUpload = true;
        this.deleteImage = imageId;
        this.imageLibService.deleteImage(imageId)
            .subscribe(returnObject => this.deleteImageFromUploadedResponse(returnObject));
    }

    deleteImageFromUploadedResponse(returnObject: IReturnObject) {
        this.clearFailObject();
        if (returnObject.ErrorMsg !== '') {
            this.errorType = 'danger';
            this.failreturnObject.push(returnObject.ErrorMsg);
        } else {
            const index = this.returnObject.findIndex(x => x.Id === this.deleteImage);
            this.errorType = 'info';
            this.failreturnObject.push('The picture is now deleted from the library');
            this.returnObject.splice(index, 1);
        }
        this.showSpinnerUpload = false;
        const that = this;
        setTimeout(function () { that.clearFailObject(); }, 10000);
    }

    SelectAllUploaded(){
        this.returnObject.forEach(x => this.selectImageToPi(x));
        if (jQuery('#SelectAllUploaded').prop('checked') === true){
            jQuery('.uloadedImagedCB').prop('checked', true);
            this.SelectAllUploadedText = 'Check to select all ';
        } else {
            jQuery('.uloadedImagedCB').prop('checked', false);
            this.SelectAllUploadedText = 'Uncheck to deselect all ';
        }
    }

    SelectAllSearched(){
        this.imageSearchResult.forEach(x => this.selectImageToPi(x));
        if (jQuery('#SelectAllSearched').prop('checked') === true){
            jQuery('.searchedImageCB').prop('checked', true);
            this.SelectAllSearchedText = 'Check to select all ';
        } else {
            jQuery('.searchedImageCB').prop('checked', false);
            this.SelectAllSearchedText = 'Check to select all ';
        }
    }


    // --------------------------------------------
    // Search labels list
    // --------------------------------------------
    searchTextChanged() {
        const that = this; // needed to preserve scope reference to this within setinterval function

        if (that.searchLabels.length >= 2) {
            that.viewList = true;
            that.dataFetched = false;
            // If this.typeDelayTimer is not nulll then the
            // user typed somthing new within time limit so reset timer
            if (that.typeDelayTimer != null) {
                clearInterval(that.typeDelayTimer);
            }

            that.typeDelayTimer = setInterval(function () {
                that.getImageLabels();
                clearInterval(that.typeDelayTimer);
            }, that.searchKeyStrokeDelay);
        } else {
            that.viewList = false;
            clearInterval(that.typeDelayTimer);
        }
    }

    hideSearchListWithDelay() {
        clearInterval(this.searchListDelayTimer);
        this.startSearchListWithDelay();
    }

    finalizeHideSearchListWithDelay() {
        this.viewList = false;
        clearInterval(this.searchListDelayTimer);
    }

    startSearchListWithDelay() {
        const that = this;
        if (!that.viewList) {
            clearInterval(that.searchListDelayTimer);
            return;
        }

        if (that.searchListDelayTimer != null) {
            clearInterval(that.searchListDelayTimer);
        }

        that.searchListDelayTimer = setInterval(function () {
            that.finalizeHideSearchListWithDelay();
        }, that.searchListDelayTimerDelay);
    }

    showSearchList() {
        if (this.searchLabels.length >= 2) {
            clearInterval(this.searchListDelayTimer);
            this.viewList = true;
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/app/image-library/image-library.component.ts